import React from 'react';
import { connect } from 'react-redux';
import { DataLoader } from '../../components/common';
import { getProjectsData } from '../../redux/actions/router';
import {
  getDeletingProjects,
  getPendingProjects,
} from '../../redux/projects/projects.selectors';
import { Project } from '../../types/entities';
import { RouterContext } from '../../types/router';
import { ProjectsContainer } from './projects.lazy';

interface Props {
  router: RouterContext;
  getProjectsData(router: RouterContext): any; // Promise<any>;
  deletingProjects: Project[];
  pendingProjects: Project[];
}

class ProjectsDataLoader extends React.Component<Props> {
  private loadData(): Promise<any> {
    const { getProjectsData, router } = this.props;
    if (!router) {
      return Promise.resolve();
    }

    return getProjectsData(router);
  }

  public render() {
    return (
      <DataLoader loadData={this.loadData.bind(this)}>
        {(props) => <ProjectsContainer {...props} />}
      </DataLoader>
    );
  }
}

const mapStateToProps = (state) => ({
  deletingProjects: getDeletingProjects(state),
  pendingProjects: getPendingProjects(state),
});

const mapDispatchToProps = {
  getProjectsData,
};

export const Projects = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectsDataLoader);
